import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PharmacyLoginPage from 'pages/PharmacyLoginPage';
import Splash from 'modules/common/components/splash/Splash';
import { status } from 'constants/general';
import initApp from 'utils/functions/init';
import {
  validateAuthCookie,
  getRoleResolutionState,
  getDefaultRouteForRole,
  ROLE_RESOLUTION_STATUS,
} from 'utils/functions/authentication';

const LoginRoute = () => {
  const isUserAuthenticated = validateAuthCookie();
  const loginInfo = useSelector(state => state.pharmacyAccountManagement.loginInfo);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isUserAuthenticated && loginInfo.status === status.SHOULD_CALL_API) {
      initApp(dispatch);
    }
  }, [dispatch, isUserAuthenticated, loginInfo.status]);

  if (isUserAuthenticated === false) {
    return <PharmacyLoginPage />;
  }

  const { status: resolutionStatus, role } = getRoleResolutionState(loginInfo);

  if (resolutionStatus === ROLE_RESOLUTION_STATUS.LOADING) {
    return <Splash />;
  }

  if (resolutionStatus === ROLE_RESOLUTION_STATUS.RESOLVED) {
    return <Navigate replace to={getDefaultRouteForRole(role)} />;
  }

  return <PharmacyLoginPage />;
};

export default LoginRoute;
